import React, { useEffect } from 'react'
import { Card as PPUICard, BodyText, MerchantIcon } from '@paypalcorp/pp-react'
import { get } from 'lodash'
import ReadMoreText from '../../ReadMoreText'
import { sendFptiImpression } from '../../../../../lib/fpti-pa'
import { SHOPPING_STORE_ITEM_SHOWN } from '../../../../../lib/client-constants'
import { StoreProfileFPTI } from '../../../../store-profile/StoreProfilePage'
import useWorldReady from 'hooks/useWorldReady'

interface Props {
  title: string
  content?: string
  icon?: Icon
  isMobile: boolean
  fptiData: StoreProfileFPTI | null
}

type Icon = {
  url?: string
  accessibilityLabel?: string
  name?: string
}

export const MAX_DESKTOP_TEXT_LENGTH = 100
export const MAX_MOBILE_TEXT_LENGTH = 55

const StoreDetailsIcon = ({ icon }: { icon?: Icon }) => {
  if (!icon) {
    return <MerchantIcon />
  }
  if (!get(icon, 'url')) {
    return null
  }
  return (
    <img
      src={get(icon, 'url')}
      aria-label={get(icon, 'accessibilityLabel') || ' '}
    />
  )
}

export const StoreDetailsInfoCard = ({
  title,
  content,
  icon,
  fptiData,
  isMobile
}: Props) => {
  const { formatMessage } = useWorldReady()

  useEffect(() => {
    sendFptiImpression({
      event_name: SHOPPING_STORE_ITEM_SHOWN,
      banner_type: 'information',
      message: title,
      ...fptiData
    })
    // FPTI need to be triggered only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="store-details-info-card">
      <PPUICard className="store-details-info-card__tile">
        <div className="store-details-info-card__header-container">
          <StoreDetailsIcon icon={icon} />
          <PPUICard.Header className="store-details-info-card__header">
            <BodyText className="store-details-info-card__text--body">
              {title}
            </BodyText>
          </PPUICard.Header>
        </div>
        <PPUICard.Content>
          <ReadMoreText
            entireText={content || ''}
            readMoreText={formatMessage(
              'main.shoppingHub.modal.offerDetails.showMore'
            )}
            showLessText={formatMessage(
              'main.shoppingHub.modal.offerDetails.showLess'
            )}
            textComponent={BodyText}
            textComponentClassname="store-details-info-card__text--body"
            maxLength={
              isMobile ? MAX_MOBILE_TEXT_LENGTH : MAX_DESKTOP_TEXT_LENGTH
            }
            theme="v2"
            className="ppvx_text--body store-details-info-card"
            fptiEvent={() => {}}
            buttonClassName="ppvx_link store-details-info-card"
          />
        </PPUICard.Content>
      </PPUICard>
    </div>
  )
}
